var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { createMedias } from './reduxMedias';
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
const initialState = {
    data: [],
    loading: false,
    count: 0,
};
export const createTakeValidationMedia = createAsyncThunk('reduxTakeValidationMedias/create', (validationsMedias_1, _a) => __awaiter(void 0, [validationsMedias_1, _a], void 0, function* (validationsMedias, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        if (validationsMedias.length > 1) {
            const promises = validationsMedias.flatMap((val) => __awaiter(void 0, void 0, void 0, function* () {
                const medias = val.medias;
                const { payload } = yield dispatch(createMedias(medias));
                return payload;
            }));
            const mediasResponse = yield Promise.all(promises);
            const relations = mediasResponse.flatMap((media, i) => {
                const relation = media.map((r) => {
                    return { media: r.id, take: validationsMedias[i].take };
                });
                return relation;
            });
            const res = yield api.takeValidationMedias.collection.create(relations);
            return fulfillWithValue(res);
        }
        const medias = validationsMedias.flatMap((el) => el.medias);
        const take = validationsMedias[0].take;
        const { payload } = yield dispatch(createMedias(medias));
        const relations = payload.map((el) => ({ media: el.id, take }));
        const res = yield api.takeValidationMedias.collection.create(relations);
        return fulfillWithValue(res);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxTakeValidationMedias',
    initialState,
    reducers: {
        createTakeValidationMediasFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (flag) => flag.id);
            state.data = newData;
        },
        deleteTakeValidationMediasFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((flag) => flag.id !== updatedPayload.id);
            state.data = newData;
        },
        setAllTakeValidationMedias: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createTakeValidationMedia.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (media) => media.id);
            state.data = newData;
        });
    },
});
export const { setAllTakeValidationMedias, createTakeValidationMediasFromWS, deleteTakeValidationMediasFromWS } = actions;
export default reducer;
